import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { rutaDeEntrada } from "../../routes/permisosRuta";

const SmartRedirect = () => {
  const { user, loading, hasPermission } = useAuth();

  // ✅ MIENTRAS CARGA
  if (loading) {
    return <div>Cargando...</div>;
  }

  // ✅ SI NO HAY USUARIO, IR A LOGIN
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  /* El mapa ruta -> permiso vive en routes/permisosRuta.js, compartido con
   * Login: ese mapa es lo que impide que un rol sin viajes.leer (Monitoreo)
   * vuelva a /dashboard tras iniciar sesión y rebote a /unauthorized. */
  const destino = rutaDeEntrada(hasPermission);

  // ✅ REDIRIGIR A LA PRIMERA RUTA ACCESIBLE
  if (destino) {
    console.log(`🔄 Redirigiendo usuario ${user.nombre} a: ${destino}`);
    return <Navigate to={destino} replace />;
  }

  // ✅ SI NO TIENE ACCESO A NADA
  console.log(`❌ Usuario ${user.nombre} sin permisos`);
  return <Navigate to="/unauthorized" replace />;
};

export default SmartRedirect;
